import settings from '../settings';
import i18n from '../settings/i18n';

const t = i18n.init('shared');

export function getShortenCountryName() {
  return settings.store === 'reebelo-us'
    ? settings.country_code
    : t(settings.country);
}
